<template>
  <form @submit.prevent="submitForm" class="form-group">
    <label for="name">Nom</label>
    <input
      id="name"
      v-model="form.name"
      type="text"
      placeholder="Votre nom"
      required
    />
    <label for="email">Email</label>
    <input
      id="email"
      v-model="form.email"
      type="email"
      placeholder="votre@email.com"
      required
    />
    <label for="message">Message</label>
    <textarea
      id="message"
      v-model="form.message"
      rows="5"
      placeholder="Votre message..."
      required
    ></textarea>
    <div class="btn-group">
      <button type="submit" class="btn btn-primary btn-full">
        Envoyer le message
      </button>
    </div>

  </form>

  <p v-if="success" class="success">
    ✅ Message envoyé avec succès !
  </p>
  <p v-if="error" class="error-message">
    ❌ Une erreur est survenue, veuillez réessayer.
  </p>

</template>

<script setup>
import { reactive, ref } from 'vue'
import { useToast } from 'vue-toast-notification'

const success = ref(false)
const error = ref(false)
const toast = useToast()

const form = reactive({
  name: '',
  email: '',
  message: ''
})

const submitForm = async () => {
  try {
    const response = await fetch('https://formspree.io/f/mreebpon', {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        name: form.name,
        email: form.email,
        message: form.message
      })
    })

    const data = await response.json()

    if (response.ok) {
      toast.success('Message envoyé avec succès !')
      success.value = true
      error.value = false

      // reset du formulaire
      form.name = ''
      form.email = ''
      form.message = ''

      setTimeout(() => {
        success.value = false
      }, 3000)
    } else {
      toast.error('Une erreur est survenue lors de l\'envoi du message.')
      error.value = true
    }
  } catch (err) {
    error.value = true
    toast.error('Une erreur est survenue lors de l\'envoi du message.')
  }
}
</script>

<style scoped>
/* .form-group { */
/*   margin-bottom: 1.5rem; */
/* } */
/**/
/* button { */
/*   width: 100%; */
/*   padding: 0.9rem; */
/*   border-radius: 10px; */
/*   border: none; */
/*   background: linear-gradient( */
/*     135deg, */
/*     var(--color-jungle), */
/*     var(--color-feuille) */
/*   ); */
/*   color: white; */
/*   font-size: 1rem; */
/*   font-weight: 600; */
/*   cursor: pointer; */
/*   transition: transform 0.2s, box-shadow 0.2s; */
/* } */
/**/
/* button:hover { */
/*   transform: translateY(-2px); */
/*   box-shadow: 0 10px 20px rgba(0, 0, 0, 0.15); */
/* } */
/**/
/* @media (max-width: 768px) { */
/*   button.btn-main { */
/*     width: 100% !important; */
/*   } */
/* } */
/**/

</style>
